import React from 'react';
import { WorkflowCard } from './components/WorkflowCard/WorkflowCard';
import { ErrorState } from '../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { WorkflowWrapper } from './Workflow.styles';

interface Props {
  onRetry(): void;
}

export const WorkflowError: React.FC<Props> = ({ onRetry }) => {
  return (
    <WorkflowWrapper>
      <WorkflowCard mt="48">
        <ErrorState onAction={onRetry} />
      </WorkflowCard>
    </WorkflowWrapper>
  );
};
